import { createWidgetRootRoute } from "@blockdaemon/widget-host";
import type { ReactNode } from "react";

import { WidgetConfigProvider } from "../features/customization/hooks/use-widget-config";
import { LocaleConfigWrapper } from "../lib/i18n/locale-config-wrapper";

function EarnShowcaseWrapper({ children }: { children: ReactNode }) {
  return <LocaleConfigWrapper>{children}</LocaleConfigWrapper>;
}

function EarnStandaloneWrapper({ children }: { children: ReactNode }) {
  return (
    <WidgetConfigProvider>
      <LocaleConfigWrapper>{children}</LocaleConfigWrapper>
    </WidgetConfigProvider>
  );
}

export const Route = createWidgetRootRoute({
  ShowcaseWrapper: EarnShowcaseWrapper,
  StandaloneWrapper: EarnStandaloneWrapper,
});
